module.exports = __webpack_public_path__ + "static/media/termos_img_form.f3f38d0d.png";